// Returns a preview image URL for a content item, or null if none available.
// - YouTube: extract videoId → img.youtube.com/vi/{ID}/hqdefault.jpg
// - Vimeo: no static URL without API call; return null (use placeholder)
// - PDF: thumbnail_path served by backend /api/thumbnails/ (public)
// - Any content with explicit thumbnail_url set manually in admin form → used as-is

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// YouTube: supports youtu.be, youtube.com/watch?v=, youtube.com/embed/, youtube.com/shorts/
const YT_ID_REGEX = /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/;

const extractYouTubeId = (url) => {
  if (!url) return null;
  const m = url.match(YT_ID_REGEX);
  return m ? m[1] : null;
};

export const getContentPreview = (content) => {
  if (!content) return null;

  // 1. Manually set URL wins (admin form)
  if (content.thumbnail_url) return content.thumbnail_url;

  // 2. PDF thumbnail generated server-side
  if (content.thumbnail_path) {
    return `${API}/thumbnails/${content.thumbnail_path}`;
  }

  // 3. YouTube auto-thumbnail
  if (content.content_type === 'video' && content.video_url) {
    const ytId = extractYouTubeId(content.video_url);
    if (ytId) return `https://img.youtube.com/vi/${ytId}/hqdefault.jpg`;
  }

  return null;
};

/** video | pdf | image | file — for badges / icons on cards */
export const getContentMediaKind = (content) => {
  if (!content) return 'file';
  if (content.content_type === 'video') return 'video';
  const fn = (content.file_name || '').toLowerCase();
  if (/\.pdf$/i.test(fn)) return 'pdf';
  if (/\.(png|jpe?g|gif|webp|bmp|svg)$/i.test(fn)) return 'image';
  return 'file';
};

export const contentKindLabel = (kind) => {
  switch (kind) {
    case 'video':
      return 'Video';
    case 'pdf':
      return 'PDF';
    case 'image':
      return 'Immagine';
    default:
      return 'File';
  }
};
